<template>
  <div class="signSuccess">
    <img class="posterBg" :src="signSuccessBg" />
    <main>
      <section>
        <dl>
          <dt class="team-name">
            {{ teamInfo.teamName || "" }}
          </dt>
          <dd class="service-point-name">{{ teamInfo.servicePointName || "" }}</dd>
        </dl>
      </section>
    </main>
  </div>
</template>

<script>
import { timeFormatFilter } from "@/util/util.js";

export default {
  name: "signSuccess",
  data() {
    return {
      isSpring: false,
      year: "",
      season: "",
      star_type: "service",
      signSuccessBg: null,
      currentSeason: "",
    };
  },
  methods: {
    timeFormatFilter(date) {
      return timeFormatFilter(date);
    },
  },
  props: {
    posterData: {
      type: Object,
      default: function () {
        return {
          realName: "",
          date: "",
          cupNumber: 0,
        };
      },
    },
    teamInfo: {
      type: Object,
      default: null,
    },
    isMVP: {
      type: Boolean,
      default: false,
    },
    // 2024冬季赛背景判断
    officialPoster:{
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    this.signSuccessBg = require(`../../../../assets/images/squirrelCup/2025/summer/poster/signSucess.png`);  },
};
</script>

<style lang="less" scoped>
.signSuccess {
  display: flex;
  flex-direction: column;
  > img {
    width: 100%;
  }
  main {
    position: absolute;
    top: 512px;
    left: 0;
    right: 0;
  }
  section {
    position: relative;
    margin-top: 30px;
    .team-name {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 64px;
      color: #FFFFFF;
      line-height: 90px;
      text-align: center;
      font-style: normal;
    }
    .service-point-name {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 36px;
      color: #FFFFFF;
      line-height: 50px;
      text-align: center;
      font-style: normal;
    }
  }
}
</style>
